module.exports = __webpack_public_path__ + "img/r-cb6-010-2.7fdeaf32.gif";